export default __webpack_public_path__ + "static/media/cover.15b51d72.png";